import React, { Component } from "react";
import { Col, Card, CardBody } from "reactstrap";
import { changeTone } from "./format";

class MiniWidgets extends Component {
  render() {
    return (
      <React.Fragment>
        {this.props.reports.map((report, key) => {
          const tone = changeTone(report.direction);
          return (
            <Col key={key} md={6}>
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-1 overflow-hidden">
                      <p className="text-truncate font-size-14 mb-2">
                        {report.title}
                      </p>
                      <h4 className="mb-0">{report.value}</h4>
                      {report.details?.length > 0 && (
                        <p className="text-muted font-size-12 mb-0 mt-2">
                          {report.details
                            .map((item) =>
                              item.value === undefined
                                ? item.label
                                : `${Number(item.value || 0).toLocaleString("en-US")} ${item.label}`,
                            )
                            .join(" · ")}
                        </p>
                      )}
                    </div>
                    <div className="text-primary">
                      <i className={report.icon + " font-size-24"}></i>
                    </div>
                  </div>
                </CardBody>

                <CardBody className="border-top py-3">
                  <div className="text-truncate">
                    <span
                      className={`badge bg-${tone.color}-subtle text-${tone.color} font-size-11 me-1`}
                    >
                      <i className={`mdi ${tone.icon}`}> </i> {report.rate}
                    </span>
                    <span className="text-muted ms-2">{report.desc}</span>
                  </div>
                </CardBody>
              </Card>
            </Col>
          );
        })}
      </React.Fragment>
    );
  }
}

export default MiniWidgets;
